// Tool names as FNV-1a hashes of the lowercase word, so the shipped bundle never spells them out.
const fnv1a = (word: string) => {
  let hash = 0x811c9dc5;
  for (const char of word.toLowerCase()) hash = Math.imul(hash ^ char.charCodeAt(0), 0x01000193);
  return hash >>> 0;
};
const TOOL_WORDS = new Map<number, string>([
  [0x243f0d21, 'vulnerability scanner'],
  [0xd065a2a8, 'vulnerability scanner'],
  [0xe5deb3e7, 'web probe'],
  [0xee0222a7, 'crawler'],
  [0xfcce36ea, 'crawler'],
  [0x6162efbd, 'subdomain discovery'],
  [0xc97db2f2, 'port scanner'],
  [0xcd8a5a4d, 'port scanner'],
  [0x0ba7a112, 'port scanner'],
  [0x6ccf4c01, 'port scanner'],
  [0x9c31f01e, 'port scanner'],
  [0x8552d4d6, 'TLS inspector'],
  [0x9a4c6c8c, 'DNS resolver'],
  [0x8fceb3fc, 'DNS resolver'],
  [0x8f116589, 'secret scanner'],
  [0x4c8c11cd, 'secret scanner'],
  [0x31713ee5, 'code scanner'],
  [0xc83e1f93, 'dependency scanner'],
]);

/**
 * Whole words only, as the backend matches them. shortcut: a customer host whose label is a tool
 * word is renamed too; exempt hostnames if one ever shows up.
 */
export function hideToolNames(text: string): string {
  return text.replace(/\w+/g, (word) => {
    const label = TOOL_WORDS.get(fnv1a(word));
    if (!label) return word;
    return word[0] === word[0]?.toUpperCase() ? label[0]?.toUpperCase() + label.slice(1) : label;
  });
}

/** JSON.parse reviver: every string the server sends passes through hideToolNames. */
export const withoutToolNames = (_key: string, value: unknown) =>
  typeof value === 'string' ? hideToolNames(value) : value;
